const checked =
	'<svg width="16" height="12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.505 11.552 0 6.046 1.057 4.99l4.448 4.449L14.943 0 16 1.057 5.505 11.552Z" fill="#139F84"/></svg>';
const minus =
	'<svg width="15" height="2" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0 1.607V0h15v1.607H0Z" fill="#AFB1BA"/></svg>';
const newBadge = '<span class="new-badge">Pro</span>';

export const comparisonList = [
	// {
	// 	featureName: 'Starting Price',
	// 	featureItems: {
	// 		dokan: {
	// 			key: '<span style="color: #000;">$149<sub style="font-size: 12px;position: relative;top: -4px;">/yr</sub></span>',
	// 		},
	// 		wcfmMarketplace: {
	// 			key: '<span style="color: #000;">$168<sub style="font-size: 12px;position: relative;top: -4px;">/yr</sub></span>',
	// 		},
	// 		wcVendor: {
	// 			key: '<span style="color: #000;">$397<sub style="font-size: 12px;position: relative;top: -4px;">/yr</sub></span>',
	// 		},
	// 		wcMarketplace: {
	// 			key: '<span style="color: #000;">$494<sub style="font-size: 12px;position: relative;top: -4px;">/yr</sub></span>',
	// 		},
	// 		yithInspiration: {
	// 			key: '<span style="color: #000;">€99,99<sub style="font-size: 12px;position: relative;top: -4px;">/yr</sub></span>',
	// 		},
	// 		wcProductVendors: {
	// 			key: '<span style="color: #000;">$79<sub style="font-size: 12px;position: relative;top: -4px;">/yr</sub></span>',
	// 		},
	// 	},
	// },
	// {
	// 	featureName: 'Active Installations',
	// 	featureItems: {
	// 		dokan: {
	// 			key: '<span style="color: #000;">70,000+</span>',
	// 		},
	// 		wcfmMarketplace: {
	// 			key: '<span style="color: #000;">30,000+</span>',
	// 		},
	// 		wcVendor: {
	// 			key: '<span style="color: #000;">10,000+</span>',
	// 		},
	// 		wcMarketplace: {
	// 			key: '<span style="color: #000;">10,000+</span>',
	// 		},
	// 		yithInspiration: {
	// 			key: minus,
	// 		},
	// 		wcProductVendors: {
	// 			key: minus,
	// 		},
	// 	},
	// },
	// {
	// 	featureName: 'WordPress.org Rating',
	// 	featureItems: {
	// 		dokan: {
	// 			key: '<div class="comparison-reviews" style="font-size: 12px;"><span style="display:block; font-size: 16px; font-weight: 600; color:#000;text-align:center;"><svg width="14" height="14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.963 5.29a.75.75 0 0 0-.64-.533l-4.04-.383L7.684.472A.744.744 0 0 0 7 0a.743.743 0 0 0-.684.472L4.719 4.374l-4.042.383a.753.753 0 0 0-.64.533.8.8 0 0 0 .217.825L3.309 8.91l-.901 4.14a.794.794 0 0 0 .29.802.72.72 0 0 0 .817.038L7 11.715l3.484 2.175c.256.16.577.145.819-.038a.794.794 0 0 0 .29-.802l-.902-4.14 3.055-2.795a.8.8 0 0 0 .217-.825Z" fill="#FEC42C"/></svg> 4.6</span> ( 500 reviews)</div>',
	// 		},
	// 		wcfmMarketplace: {
	// 			key: '<div class="comparison-reviews" style="font-size: 12px;"><span style="display:block; font-size: 16px; font-weight: 600; color:#000;text-align:center;"><svg width="14" height="14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.963 5.29a.75.75 0 0 0-.64-.533l-4.04-.383L7.684.472A.744.744 0 0 0 7 0a.743.743 0 0 0-.684.472L4.719 4.374l-4.042.383a.753.753 0 0 0-.64.533.8.8 0 0 0 .217.825L3.309 8.91l-.901 4.14a.794.794 0 0 0 .29.802.72.72 0 0 0 .817.038L7 11.715l3.484 2.175c.256.16.577.145.819-.038a.794.794 0 0 0 .29-.802l-.902-4.14 3.055-2.795a.8.8 0 0 0 .217-.825Z" fill="#FEC42C"/></svg> 4.5</span> (335 reviews)</div>',
	// 		},
	// 		wcVendor: {
	// 			key: '<div class="comparison-reviews" style="font-size: 12px;"><span style="display:block; font-size: 16px; font-weight: 600; color:#000;text-align:center;"><svg width="14" height="14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.963 5.29a.75.75 0 0 0-.64-.533l-4.04-.383L7.684.472A.744.744 0 0 0 7 0a.743.743 0 0 0-.684.472L4.719 4.374l-4.042.383a.753.753 0 0 0-.64.533.8.8 0 0 0 .217.825L3.309 8.91l-.901 4.14a.794.794 0 0 0 .29.802.72.72 0 0 0 .817.038L7 11.715l3.484 2.175c.256.16.577.145.819-.038a.794.794 0 0 0 .29-.802l-.902-4.14 3.055-2.795a.8.8 0 0 0 .217-.825Z" fill="#FEC42C"/></svg> 4.4</span> (140 reviews)</div>',
	// 		},
	// 		wcMarketplace: {
	// 			key: '<div class="comparison-reviews" style="font-size: 12px;"><span style="display:block; font-size: 16px; font-weight: 600; color:#000;text-align:center;"><svg width="14" height="14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.963 5.29a.75.75 0 0 0-.64-.533l-4.04-.383L7.684.472A.744.744 0 0 0 7 0a.743.743 0 0 0-.684.472L4.719 4.374l-4.042.383a.753.753 0 0 0-.64.533.8.8 0 0 0 .217.825L3.309 8.91l-.901 4.14a.794.794 0 0 0 .29.802.72.72 0 0 0 .817.038L7 11.715l3.484 2.175c.256.16.577.145.819-.038a.794.794 0 0 0 .29-.802l-.902-4.14 3.055-2.795a.8.8 0 0 0 .217-.825Z" fill="#FEC42C"/></svg> 4.4</span> (320 reviews)</div>',
	// 		},
	// 		yithInspiration: {
	// 			key: minus,
	// 		},
	// 		wcProductVendors: {
	// 			key: minus,
	// 		},
	// 	},
	// },
	// {
	// 	featureName: 'Trust Pilot',
	// 	featureItems: {
	// 		dokan: {
	// 			key: '<div class="comparison-reviews" style="font-size: 12px;"><span style="display:block; font-size: 16px; font-weight: 600; color:#000;text-align:center;"><svg width="14" height="14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.963 5.29a.75.75 0 0 0-.64-.533l-4.04-.383L7.684.472A.744.744 0 0 0 7 0a.743.743 0 0 0-.684.472L4.719 4.374l-4.042.383a.753.753 0 0 0-.64.533.8.8 0 0 0 .217.825L3.309 8.91l-.901 4.14a.794.794 0 0 0 .29.802.72.72 0 0 0 .817.038L7 11.715l3.484 2.175c.256.16.577.145.819-.038a.794.794 0 0 0 .29-.802l-.902-4.14 3.055-2.795a.8.8 0 0 0 .217-.825Z" fill="#FEC42C"/></svg> 4.8</span> ( 431 reviews)</div>',
	// 		},
	// 		wcfmMarketplace: {
	// 			key: minus,
	// 		},
	// 		wcVendor: {
	// 			key: '<div class="comparison-reviews" style="font-size: 12px;"><span style="display:block; font-size: 16px; font-weight: 600; color:#000;text-align:center;"><svg width="14" height="14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.963 5.29a.75.75 0 0 0-.64-.533l-4.04-.383L7.684.472A.744.744 0 0 0 7 0a.743.743 0 0 0-.684.472L4.719 4.374l-4.042.383a.753.753 0 0 0-.64.533.8.8 0 0 0 .217.825L3.309 8.91l-.901 4.14a.794.794 0 0 0 .29.802.72.72 0 0 0 .817.038L7 11.715l3.484 2.175c.256.16.577.145.819-.038a.794.794 0 0 0 .29-.802l-.902-4.14 3.055-2.795a.8.8 0 0 0 .217-.825Z" fill="#FEC42C"/></svg> 3.7</span> (4 reviews)</div>',
	// 		},
	// 		wcMarketplace: {
	// 			key: minus,
	// 		},
	// 		yithInspiration: {
	// 			key: '<div class="comparison-reviews" style="font-size: 12px;"><span style="display:block; font-size: 16px; font-weight: 600; color:#000;text-align:center;"><svg width="14" height="14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.963 5.29a.75.75 0 0 0-.64-.533l-4.04-.383L7.684.472A.744.744 0 0 0 7 0a.743.743 0 0 0-.684.472L4.719 4.374l-4.042.383a.753.753 0 0 0-.64.533.8.8 0 0 0 .217.825L3.309 8.91l-.901 4.14a.794.794 0 0 0 .29.802.72.72 0 0 0 .817.038L7 11.715l3.484 2.175c.256.16.577.145.819-.038a.794.794 0 0 0 .29-.802l-.902-4.14 3.055-2.795a.8.8 0 0 0 .217-.825Z" fill="#FEC42C"/></svg> 4.7</span> (1009 reviews)</div>',
	// 		},
	// 		wcProductVendors: {
	// 			key: minus,
	// 		},
	// 	},
	// },

	{
		featureName: `Printful Integration ${ newBadge }`,
		featureItems: {
			dokan: {
				key: checked,
			},
			wcfmMarketplace: {
				key: minus,
			},
			wcVendor: {
				key: minus,
			},
			wcMarketplace: {
				key: minus,
			},
			yithInspiration: {
				key: minus,
			},
			wcProductVendors: {
				key: minus,
			},
		},
	},

	{
		featureName: `Dokan MangoPay Integration ${ newBadge }`,
		featureItems: {
			dokan: {
				key: checked,
			},
			wcfmMarketplace: {
				key: minus,
			},
			wcVendor: {
				key: checked,
			},
			wcMarketplace: {
				key: checked,
			},
			yithInspiration: {
				key: minus,
			},
			wcProductVendors: {
				key: minus,
			},
		},
	},

	{
		featureName: `Minimum Maximum Order ${ newBadge }`,
		featureItems: {
			dokan: {
				key: checked,
			},
			wcfmMarketplace: {
				key: minus,
			},
			wcVendor: {
				key: minus,
			},
			wcMarketplace: {
				key: minus,
			},
			yithInspiration: {
				key: minus,
			},
			wcProductVendors: {
				key: minus,
			},
		},
	},

	{
		featureName: `Razorpay ${ newBadge }`,
		featureItems: {
			dokan: {
				key: checked,
			},
			wcfmMarketplace: {
				key: minus,
			},
			wcVendor: {
				key: minus,
			},
			wcMarketplace: {
				key: checked,
			},
			yithInspiration: {
				key: minus,
			},
			wcProductVendors: {
				key: minus,
			},
		},
	},

	{
		featureName: `Product Advertising${ newBadge }`,
		featureItems: {
			dokan: {
				key: checked,
			},
			wcfmMarketplace: {
				key: minus,
			},
			wcVendor: {
				key: minus,
			},
			wcMarketplace: {
				key: minus,
			},
			yithInspiration: {
				key: minus,
			},
			wcProductVendors: {
				key: minus,
			},
		},
	},

	{
		featureName: `Stripe Connect ${ newBadge }`,
		featureItems: {
			dokan: {
				key: checked,
			},
			wcfmMarketplace: {
				key: minus,
			},
			wcVendor: {
				key: checked,
			},
			wcMarketplace: {
				key: minus,
			},
			yithInspiration: {
				key: checked,
			},
			wcProductVendors: {
				key: minus,
			},
		},
	},
	{
		featureName: `Table Rate Shipping ${ newBadge }`,
		featureItems: {
			dokan: {
				key: checked,
			},
			wcfmMarketplace: {
				key: minus,
			},
			wcVendor: {
				key: checked,
			},
			wcMarketplace: {
				key: checked,
			},
			yithInspiration: {
				key: minus,
			},
			wcProductVendors: {
				key: minus,
			},
		},
	},
	{
		featureName: `Elementor ${ newBadge }`,
		featureItems: {
			dokan: {
				key: checked,
			},
			wcfmMarketplace: {
				key: minus,
			},
			wcVendor: {
				key: minus,
			},
			wcMarketplace: {
				key: minus,
			},
			yithInspiration: {
				key: minus,
			},
			wcProductVendors: {
				key: minus,
			},
		},
	},
	{
		featureName: `Rank Math SEO ${ newBadge }`,
		featureItems: {
			dokan: {
				key: checked,
			},
			wcfmMarketplace: {
				key: minus,
			},
			wcVendor: {
				key: checked,
			},
			wcMarketplace: {
				key: minus,
			},
			yithInspiration: {
				key: minus,
			},
			wcProductVendors: {
				key: minus,
			},
		},
	},

	{
		featureName: `Dokan PayPal Marketplace ${ newBadge }`,
		featureItems: {
			dokan: {
				key: checked,
			},
			wcfmMarketplace: {
				key: minus,
			},
			wcVendor: {
				key: minus,
			},
			wcMarketplace: {
				key: checked,
			},
			yithInspiration: {
				key: minus,
			},
			wcProductVendors: {
				key: minus,
			},
		},
	},
	{
		featureName: `Delivery Time ${ newBadge }`,
		featureItems: {
			dokan: {
				key: checked,
			},
			wcfmMarketplace: {
				key: minus,
			},
			wcVendor: {
				key: minus,
			},
			wcMarketplace: {
				key: minus,
			},
			yithInspiration: {
				key: minus,
			},
			wcProductVendors: {
				key: minus,
			},
		},
	},
	{
		featureName: `Product Subscription ${ newBadge }`,
		featureItems: {
			dokan: {
				key: checked,
			},
			wcfmMarketplace: {
				key: minus,
			},
			wcVendor: {
				key: checked,
			},
			wcMarketplace: {
				key: minus,
			},
			yithInspiration: {
				key: checked,
			},
			wcProductVendors: {
				key: minus,
			},
		},
	},
	{
		featureName: `Product Addon ${ newBadge }`,
		featureItems: {
			dokan: {
				key: checked,
			},
			wcfmMarketplace: {
				key: minus,
			},
			wcVendor: {
				key: minus,
			},
			wcMarketplace: {
				key: minus,
			},
			yithInspiration: {
				key: minus,
			},
			wcProductVendors: {
				key: minus,
			},
		},
	},
	{
		featureName: `WPML Integration ${ newBadge }`,
		featureItems: {
			dokan: {
				key: checked,
			},
			wcfmMarketplace: {
				key: checked,
			},
			wcVendor: {
				key: minus,
			},
			wcMarketplace: {
				key: minus,
			},
			yithInspiration: {
				key: minus,
			},
			wcProductVendors: {
				key: minus,
			},
		},
	},
	{
		featureName: `Duplicate Product ${ newBadge }`,
		featureItems: {
			dokan: {
				key: checked,
			},
			wcfmMarketplace: {
				key: minus,
			},
			wcVendor: {
				key: minus,
			},
			wcMarketplace: {
				key: minus,
			},
			yithInspiration: {
				key: minus,
			},
			wcProductVendors: {
				key: minus,
			},
		},
	},
	{
		featureName: `Color Scheme ${ newBadge }`,
		featureItems: {
			dokan: {
				key: checked,
			},
			wcfmMarketplace: {
				key: minus,
			},
			wcVendor: {
				key: minus,
			},
			wcMarketplace: {
				key: minus,
			},
			yithInspiration: {
				key: minus,
			},
			wcProductVendors: {
				key: minus,
			},
		},
	},
	{
		featureName: `Vendor Review ${ newBadge }`,
		featureItems: {
			dokan: {
				key: checked,
			},
			wcfmMarketplace: {
				key: minus,
			},
			wcVendor: {
				key: checked,
			},
			wcMarketplace: {
				key: minus,
			},
			yithInspiration: {
				key: minus,
			},
			wcProductVendors: {
				key: minus,
			},
		},
	},
	{
		featureName: `Store Support ${ newBadge }`,
		featureItems: {
			dokan: {
				key: checked,
			},
			wcfmMarketplace: {
				key: minus,
			},
			wcVendor: {
				key: minus,
			},
			wcMarketplace: {
				key: minus,
			},
			yithInspiration: {
				key: minus,
			},
			wcProductVendors: {
				key: minus,
			},
		},
	},
	{
		featureName: `Seller Verification ${ newBadge }`,
		featureItems: {
			dokan: {
				key: checked,
			},
			wcfmMarketplace: {
				key: checked,
			},
			wcVendor: {
				key: minus,
			},
			wcMarketplace: {
				key: checked,
			},
			yithInspiration: {
				key: minus,
			},
			wcProductVendors: {
				key: minus,
			},
		},
	},
	{
		featureName: `Subscriptions ${ newBadge }`,
		featureItems: {
			dokan: {
				key: checked,
			},
			wcfmMarketplace: {
				key: checked,
			},
			wcVendor: {
				key: checked,
			},
			wcMarketplace: {
				key: checked,
			},
			yithInspiration: {
				key: checked,
			},
			wcProductVendors: {
				key: minus,
			},
		},
	},
	{
		featureName: `Ajax Live Search ${ newBadge }`,
		featureItems: {
			dokan: {
				key: checked,
			},
			wcfmMarketplace: {
				key: minus,
			},
			wcVendor: {
				key: minus,
			},
			wcMarketplace: {
				key: minus,
			},
			yithInspiration: {
				key: checked,
			},
			wcProductVendors: {
				key: minus,
			},
		},
	},
	{
		featureName: `Single Product Multivendor ${ newBadge }`,
		featureItems: {
			dokan: {
				key: checked,
			},
			wcfmMarketplace: {
				key: checked,
			},
			wcVendor: {
				key: minus,
			},
			wcMarketplace: {
				key: minus,
			},
			yithInspiration: {
				key: minus,
			},
			wcProductVendors: {
				key: minus,
			},
		},
	},
	{
		featureName: `Follow Store ${ newBadge }`,
		featureItems: {
			dokan: {
				key: checked,
			},
			wcfmMarketplace: {
				key: minus,
			},
			wcVendor: {
				key: minus,
			},
			wcMarketplace: {
				key: minus,
			},
			yithInspiration: {
				key: minus,
			},
			wcProductVendors: {
				key: minus,
			},
		},
	},
	{
		featureName: `Vendor Statements ${ newBadge }`,
		featureItems: {
			dokan: {
				key: checked,
			},
			wcfmMarketplace: {
				key: minus,
			},
			wcVendor: {
				key: checked,
			},
			wcMarketplace: {
				key: checked,
			},
			yithInspiration: {
				key: checked,
			},
			wcProductVendors: {
				key: checked,
			},
		},
	},
	{
		featureName: `Making Announcements ${ newBadge }`,
		featureItems: {
			dokan: {
				key: checked,
			},
			wcfmMarketplace: {
				key: minus,
			},
			wcVendor: {
				key: minus,
			},
			wcMarketplace: {
				key: minus,
			},
			yithInspiration: {
				key: minus,
			},
			wcProductVendors: {
				key: minus,
			},
		},
	},
	{
		featureName: `Social Login & Registration ${ newBadge }`,
		featureItems: {
			dokan: {
				key: checked,
			},
			wcfmMarketplace: {
				key: minus,
			},
			wcVendor: {
				key: minus,
			},
			wcMarketplace: {
				key: minus,
			},
			yithInspiration: {
				key: minus,
			},
			wcProductVendors: {
				key: minus,
			},
		},
	},
	{
		featureName: `Moip ${ newBadge }`,
		featureItems: {
			dokan: {
				key: checked,
			},
			wcfmMarketplace: {
				key: minus,
			},
			wcVendor: {
				key: minus,
			},
			wcMarketplace: {
				key: minus,
			},
			yithInspiration: {
				key: minus,
			},
			wcProductVendors: {
				key: minus,
			},
		},
	},
	{
		featureName: `Return and Warranty Request ${ newBadge }`,
		featureItems: {
			dokan: {
				key: checked,
			},
			wcfmMarketplace: {
				key: checked,
			},
			wcVendor: {
				key: minus,
			},
			wcMarketplace: {
				key: minus,
			},
			yithInspiration: {
				key: minus,
			},
			wcProductVendors: {
				key: minus,
			},
		},
	},
	{
		featureName: `Vendor Staff Manager ${ newBadge }`,
		featureItems: {
			dokan: {
				key: checked,
			},
			wcfmMarketplace: {
				key: minus,
			},
			wcVendor: {
				key: minus,
			},
			wcMarketplace: {
				key: checked,
			},
			yithInspiration: {
				key: minus,
			},
			wcProductVendors: {
				key: minus,
			},
		},
	},
	{
		featureName: `Export Import ${ newBadge }`,
		featureItems: {
			dokan: {
				key: checked,
			},
			wcfmMarketplace: {
				key: minus,
			},
			wcVendor: {
				key: checked,
			},
			wcMarketplace: {
				key: minus,
			},
			yithInspiration: {
				key: minus,
			},
			wcProductVendors: {
				key: minus,
			},
		},
	},
	{
		featureName: 'Frontend Dashboard for Vendors',
		featureItems: {
			dokan: {
				key: checked,
			},
			wcfmMarketplace: {
				key: checked,
			},
			wcVendor: {
				key: checked,
			},
			wcMarketplace: {
				key: checked,
			},
			yithInspiration: {
				key: checked,
			},
			wcProductVendors: {
				key: minus,
			},
		},
	},
	{
		featureName: 'Frontend Simple Product',
		featureItems: {
			dokan: {
				key: checked,
			},
			wcfmMarketplace: {
				key: checked,
			},
			wcVendor: {
				key: checked,
			},
			wcMarketplace: {
				key: checked,
			},
			yithInspiration: {
				key: checked,
			},
			wcProductVendors: {
				key: minus,
			},
		},
	},
	{
		featureName: 'Order Management',
		featureItems: {
			dokan: {
				key: checked,
			},
			wcfmMarketplace: {
				key: checked,
			},
			wcVendor: {
				key: checked,
			},
			wcMarketplace: {
				key: checked,
			},
			yithInspiration: {
				key: checked,
			},
			wcProductVendors: {
				key: checked,
			},
		},
	},
	{
		featureName: 'Withdraw System for Vendors',
		featureItems: {
			dokan: {
				key: checked,
			},
			wcfmMarketplace: {
				key: checked,
			},
			wcVendor: {
				key: checked,
			},
			wcMarketplace: {
				key: checked,
			},
			yithInspiration: {
				key: checked,
			},
			wcProductVendors: {
				key: minus,
			},
		},
	},
	{
		featureName: 'Individual Vendor Stores',
		featureItems: {
			dokan: {
				key: checked,
			},
			wcfmMarketplace: {
				key: checked,
			},
			wcVendor: {
				key: checked,
			},
			wcMarketplace: {
				key: checked,
			},
			yithInspiration: {
				key: checked,
			},
			wcProductVendors: {
				key: checked,
			},
		},
	},
	{
		featureName: 'Order Email Notifications',
		featureItems: {
			dokan: {
				key: checked,
			},
			wcfmMarketplace: {
				key: minus,
			},
			wcVendor: {
				key: checked,
			},
			wcMarketplace: {
				key: checked,
			},
			yithInspiration: {
				key: checked,
			},
			wcProductVendors: {
				key: checked,
			},
		},
	},
	{
		featureName: 'Storefront Widgets',
		featureItems: {
			dokan: {
				key: checked,
			},
			wcfmMarketplace: {
				key: checked,
			},
			wcVendor: {
				key: minus,
			},
			wcMarketplace: {
				key: checked,
			},
			yithInspiration: {
				key: minus,
			},
			wcProductVendors: {
				key: minus,
			},
		},
	},
	{
		featureName: `Product Bulk Edit ${ newBadge }`,
		featureItems: {
			dokan: {
				key: checked,
			},
			wcfmMarketplace: {
				key: checked,
			},
			wcVendor: {
				key: minus,
			},
			wcMarketplace: {
				key: minus,
			},
			yithInspiration: {
				key: checked,
			},
			wcProductVendors: {
				key: minus,
			},
		},
	},
	{
		featureName: `Product Enquiry ${ newBadge }`,
		featureItems: {
			dokan: {
				key: checked,
			},
			wcfmMarketplace: {
				key: checked,
			},
			wcVendor: {
				key: minus,
			},
			wcMarketplace: {
				key: minus,
			},
			yithInspiration: {
				key: minus,
			},
			wcProductVendors: {
				key: minus,
			},
		},
	},
	{
		featureName: `Geolocation ${ newBadge }`,
		featureItems: {
			dokan: {
				key: checked,
			},
			wcfmMarketplace: {
				key: checked,
			},
			wcVendor: {
				key: minus,
			},
			wcMarketplace: {
				key: minus,
			},
			yithInspiration: {
				key: minus,
			},
			wcProductVendors: {
				key: minus,
			},
		},
	},
	{
		featureName: `WC Booking Integration ${ newBadge }`,
		featureItems: {
			dokan: {
				key: checked,
			},
			wcfmMarketplace: {
				key: minus,
			},
			wcVendor: {
				key: checked,
			},
			wcMarketplace: {
				key: checked,
			},
			yithInspiration: {
				key: checked,
			},
			wcProductVendors: {
				key: checked,
			},
		},
	},
	{
		featureName: `Admin Coupon Support ${ newBadge }`,
		featureItems: {
			dokan: {
				key: checked,
			},
			wcfmMarketplace: {
				key: checked,
			},
			wcVendor: {
				key: checked,
			},
			wcMarketplace: {
				key: checked,
			},
			yithInspiration: {
				key: checked,
			},
			wcProductVendors: {
				key: minus,
			},
		},
	},
	{
		featureName: `Multiple Commission Types ${ newBadge }`,
		featureItems: {
			dokan: {
				key: checked,
			},
			wcfmMarketplace: {
				key: checked,
			},
			wcVendor: {
				key: checked,
			},
			wcMarketplace: {
				key: checked,
			},
			yithInspiration: {
				key: checked,
			},
			wcProductVendors: {
				key: checked,
			},
		},
	},
	{
		featureName: `Multiple Product Category ${ newBadge }`,
		featureItems: {
			dokan: {
				key: checked,
			},
			wcfmMarketplace: {
				key: checked,
			},
			wcVendor: {
				key: checked,
			},
			wcMarketplace: {
				key: checked,
			},
			yithInspiration: {
				key: checked,
			},
			wcProductVendors: {
				key: checked,
			},
		},
	},
	{
		featureName: `Frontend Variable Products ${ newBadge }`,
		featureItems: {
			dokan: {
				key: checked,
			},
			wcfmMarketplace: {
				key: checked,
			},
			wcVendor: {
				key: checked,
			},
			wcMarketplace: {
				key: minus,
			},
			yithInspiration: {
				key: checked,
			},
			wcProductVendors: {
				key: minus,
			},
		},
	},
	{
		featureName: `Admin Reports ${ newBadge }`,
		featureItems: {
			dokan: {
				key: checked,
			},
			wcfmMarketplace: {
				key: checked,
			},
			wcVendor: {
				key: checked,
			},
			wcMarketplace: {
				key: checked,
			},
			yithInspiration: {
				key: checked,
			},
			wcProductVendors: {
				key: checked,
			},
		},
	},
	{
		featureName: `Earning Reports ${ newBadge }`,
		featureItems: {
			dokan: {
				key: checked,
			},
			wcfmMarketplace: {
				key: checked,
			},
			wcVendor: {
				key: checked,
			},
			wcMarketplace: {
				key: checked,
			},
			yithInspiration: {
				key: checked,
			},
			wcProductVendors: {
				key: checked,
			},
		},
	},
	{
		featureName: `Live Chat ${ newBadge }`,
		featureItems: {
			dokan: {
				key: checked,
			},
			wcfmMarketplace: {
				key: checked,
			},
			wcVendor: {
				key: minus,
			},
			wcMarketplace: {
				key: minus,
			},
			yithInspiration: {
				key: checked,
			},
			wcProductVendors: {
				key: minus,
			},
		},
	},
	{
		featureName: `ShipStation ${ newBadge }`,
		featureItems: {
			dokan: {
				key: checked,
			},
			wcfmMarketplace: {
				key: minus,
			},
			wcVendor: {
				key: minus,
			},
			wcMarketplace: {
				key: minus,
			},
			yithInspiration: {
				key: minus,
			},
			wcProductVendors: {
				key: minus,
			},
		},
	},
	{
		featureName: `Auction ${ newBadge }`,
		featureItems: {
			dokan: {
				key: checked,
			},
			wcfmMarketplace: {
				key: minus,
			},
			wcVendor: {
				key: checked,
			},
			wcMarketplace: {
				key: checked,
			},
			yithInspiration: {
				key: checked,
			},
			wcProductVendors: {
				key: minus,
			},
		},
	},
	{
		featureName: `Vendor Vacation ${ newBadge }`,
		featureItems: {
			dokan: {
				key: checked,
			},
			wcfmMarketplace: {
				key: minus,
			},
			wcVendor: {
				key: checked,
			},
			wcMarketplace: {
				key: minus,
			},
			yithInspiration: {
				key: checked,
			},
			wcProductVendors: {
				key: minus,
			},
		},
	},
	{
		featureName: `Wholesale ${ newBadge }`,
		featureItems: {
			dokan: {
				key: checked,
			},
			wcfmMarketplace: {
				key: minus,
			},
			wcVendor: {
				key: minus,
			},
			wcMarketplace: {
				key: minus,
			},
			yithInspiration: {
				key: minus,
			},
			wcProductVendors: {
				key: minus,
			},
		},
	},

	{
		featureName: `EU Compliance Fields ${ newBadge }`,
		featureItems: {
			dokan: {
				key: checked,
			},
			wcfmMarketplace: {
				key: minus,
			},
			wcVendor: {
				key: minus,
			},
			wcMarketplace: {
				key: minus,
			},
			yithInspiration: {
				key: minus,
			},
			wcProductVendors: {
				key: minus,
			},
		},
	},
	{
		featureName: `Report Abuse ${ newBadge }`,
		featureItems: {
			dokan: {
				key: checked,
			},
			wcfmMarketplace: {
				key: minus,
			},
			wcVendor: {
				key: minus,
			},
			wcMarketplace: {
				key: checked,
			},
			yithInspiration: {
				key: minus,
			},
			wcProductVendors: {
				key: minus,
			},
		},
	},
	{
		featureName: 'Pdf Invoice',
		featureItems: {
			dokan: {
				key: checked,
			},
			wcfmMarketplace: {
				key: checked,
			},
			wcVendor: {
				key: checked,
			},
			wcMarketplace: {
				key: checked,
			},
			yithInspiration: {
				key: checked,
			},
			wcProductVendors: {
				key: minus,
			},
		},
	},
];
